/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    GlobalFilterFormConfiguration,
    GlobalFilterFormConfigurationFromJSON,
    GlobalFilterFormConfigurationToJSON,
    GlobalFilterFormData,
    GlobalFilterFormDataFromJSON,
    GlobalFilterFormDataToJSON,
    GlobalFilterListItem,
    GlobalFilterListItemFromJSON,
    GlobalFilterListItemToJSON,
    GlobalFilterRuleFormConfiguration,
    GlobalFilterRuleFormConfigurationFromJSON,
    GlobalFilterRuleFormConfigurationToJSON,
    GlobalFilterRuleFormData,
    GlobalFilterRuleFormDataFromJSON,
    GlobalFilterRuleFormDataToJSON,
    GlobalFilterRuleFormValidationData,
    GlobalFilterRuleFormValidationDataFromJSON,
    GlobalFilterRuleFormValidationDataToJSON,
    GlobalFilterValidationData,
    GlobalFilterValidationDataFromJSON,
    GlobalFilterValidationDataToJSON,
} from '../models';

export interface ApiGlobalFilterGlobalFilterRuleFormConfigurationGetRequest {
    brand?: number;
    market?: string;
}

export interface ApiGlobalFilterGlobalFilterRuleFormCreatePostRequest {
    globalFilterRuleFormData?: GlobalFilterRuleFormData;
}

export interface ApiGlobalFilterGlobalFilterRuleFormDataGetRequest {
    id?: string;
}

export interface ApiGlobalFilterGlobalFilterRuleFormIdDeleteRequest {
    id: string;
}

export interface ApiGlobalFilterGlobalFilterRuleFormUpdatePostRequest {
    globalFilterRuleFormData?: GlobalFilterRuleFormData;
}

export interface ApiGlobalFilterGlobalFilterRuleFormValidatePostRequest {
    globalFilterRuleFormData?: GlobalFilterRuleFormData;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleFormCreatePostRequest {
    globalFilterFormData?: GlobalFilterFormData;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleFormDeleteDeleteRequest {
    id?: string;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleFormGetByIdGetRequest {
    id?: string;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleFormUpdatePostRequest {
    globalFilterFormData?: GlobalFilterFormData;
}

export interface ApiGlobalFiltersV2GlobalFilterRuleFormValidatePostRequest {
    globalFilterFormData?: GlobalFilterFormData;
}

/**
 * no description
 */
export class GlobalFilterRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormConfigurationGetRaw(requestParameters: ApiGlobalFilterGlobalFilterRuleFormConfigurationGetRequest): Promise<runtime.ApiResponse<GlobalFilterRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.brand !== undefined) {
            queryParameters['brand'] = requestParameters.brand;
        }

        if (requestParameters.market !== undefined) {
            queryParameters['market'] = requestParameters.market;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilter/GlobalFilterRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormConfigurationGet(requestParameters: ApiGlobalFilterGlobalFilterRuleFormConfigurationGetRequest): Promise<GlobalFilterRuleFormConfiguration> {
        const response = await this.apiGlobalFilterGlobalFilterRuleFormConfigurationGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormCreatePostRaw(requestParameters: ApiGlobalFilterGlobalFilterRuleFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilter/GlobalFilterRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterRuleFormDataToJSON(requestParameters.globalFilterRuleFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormCreatePost(requestParameters: ApiGlobalFilterGlobalFilterRuleFormCreatePostRequest): Promise<string> {
        const response = await this.apiGlobalFilterGlobalFilterRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormDataGetRaw(requestParameters: ApiGlobalFilterGlobalFilterRuleFormDataGetRequest): Promise<runtime.ApiResponse<GlobalFilterRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilter/GlobalFilterRuleForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormDataGet(requestParameters: ApiGlobalFilterGlobalFilterRuleFormDataGetRequest): Promise<GlobalFilterRuleFormData> {
        const response = await this.apiGlobalFilterGlobalFilterRuleFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormIdDeleteRaw(requestParameters: ApiGlobalFilterGlobalFilterRuleFormIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiGlobalFilterGlobalFilterRuleFormIdDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilter/GlobalFilterRuleForm/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormIdDelete(requestParameters: ApiGlobalFilterGlobalFilterRuleFormIdDeleteRequest): Promise<void> {
        await this.apiGlobalFilterGlobalFilterRuleFormIdDeleteRaw(requestParameters);
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormUpdatePostRaw(requestParameters: ApiGlobalFilterGlobalFilterRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilter/GlobalFilterRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterRuleFormDataToJSON(requestParameters.globalFilterRuleFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormUpdatePost(requestParameters: ApiGlobalFilterGlobalFilterRuleFormUpdatePostRequest): Promise<void> {
        await this.apiGlobalFilterGlobalFilterRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormValidatePostRaw(requestParameters: ApiGlobalFilterGlobalFilterRuleFormValidatePostRequest): Promise<runtime.ApiResponse<GlobalFilterRuleFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFilter/GlobalFilterRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterRuleFormDataToJSON(requestParameters.globalFilterRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterRuleFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFilterGlobalFilterRuleFormValidatePost(requestParameters: ApiGlobalFilterGlobalFilterRuleFormValidatePostRequest): Promise<GlobalFilterRuleFormValidationData> {
        const response = await this.apiGlobalFilterGlobalFilterRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormCreatePostRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormCreatePostRequest): Promise<runtime.ApiResponse<GlobalFilterListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterFormDataToJSON(requestParameters.globalFilterFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterListItemFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormCreatePost(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormCreatePostRequest): Promise<GlobalFilterListItem> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormDeleteDeleteRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormDeleteDeleteRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleForm/Delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormDeleteDelete(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormDeleteDeleteRequest): Promise<void> {
        await this.apiGlobalFiltersV2GlobalFilterRuleFormDeleteDeleteRaw(requestParameters);
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormFormConfigurationGetRaw(): Promise<runtime.ApiResponse<GlobalFilterFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleForm/FormConfiguration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormFormConfigurationGet(): Promise<GlobalFilterFormConfiguration> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleFormFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormGetByIdGetRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormGetByIdGetRequest): Promise<runtime.ApiResponse<GlobalFilterFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleForm/GetById`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormGetByIdGet(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormGetByIdGetRequest): Promise<GlobalFilterFormData> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleFormGetByIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormUpdatePostRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterFormDataToJSON(requestParameters.globalFilterFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormUpdatePost(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormUpdatePostRequest): Promise<void> {
        await this.apiGlobalFiltersV2GlobalFilterRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormValidatePostRaw(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormValidatePostRequest): Promise<runtime.ApiResponse<GlobalFilterValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/GlobalFiltersV2/GlobalFilterRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GlobalFilterFormDataToJSON(requestParameters.globalFilterFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalFilterValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiGlobalFiltersV2GlobalFilterRuleFormValidatePost(requestParameters: ApiGlobalFiltersV2GlobalFilterRuleFormValidatePostRequest): Promise<GlobalFilterValidationData> {
        const response = await this.apiGlobalFiltersV2GlobalFilterRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
